import React from 'react';
import {
  LinkStyled, Heading1, Heading3, Bold, Paragraph, Span,
} from '../components/typography';
import { Row, Col, Container } from '../components/grid';
import { Image } from '../components/Image';
import { ScreenSizeDetector } from '../lib/helpers';
import SidemenuLayout from '../layout/DefaultLayout/Layouts/SidemenuLayout';

const ImageKontakt = ({
  name,
  alt,
}) => (
  <ScreenSizeDetector imageWidth={[[575, '545px'], [767, '240px'], [991, '345px'], [1199, '500px'], '540px']} maxWidth={[[575, '545px'], [767, '240px'], [991, '345px'], [1199, '500px'], '540px']}>
    <Image name={name} alt={alt} />
  </ScreenSizeDetector>
);

export default () => (
  <SidemenuLayout menuPicker="OmOs" activeSidemenu="OmOs">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Peter Skafte ApS <Span fontSize="16px" grey>CVR: 14 29 04 00</Span></Heading1>
          <Heading3>Leverer øl, sodavand &amp; kildevand samt udlejer fadølsanlæg</Heading3>
          <Paragraph fontSize="16px">
            Stiftet 1984 af Ølhandler Peter Skafte.<br />
            Anpartsselskab siden 1990. Selskabet ejes 100% af Peter Skafte.
          </Paragraph>
          <Paragraph>
            Virksomheden består af:<br />
            Administration og odremodtagelse: 2 ansatte<br />
            Lager og teknik: 2 ansatte<br />
            Chauffører: 5 ansatte.
          </Paragraph>
          <Paragraph>
            800 m<sup>2</sup> øl & vand lager + 60 m<sup>2</sup> administration/kontor.
            Tre store lastbiler + tre varevogne med trailer.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3>Medarbejdere</Heading3>
        </Col>
        <Col xs={12} sm={6}>
          <ImageKontakt name="kontakt.peter-skafte.jpg" alt="Peter leverer af øl &amp; sodavand" />
          <br /><br />
          <Paragraph>
            <Bold>
              Direktør<br />
              Ølhandler Peter Skafte
            </Bold>
          </Paragraph>
          <Paragraph>
            Født 1965. Peter har ejet og drevet firmaet siden 1984.<br />
            Link til <LinkStyled to="/historie">historie</LinkStyled> og gamle billeder.<br />
            Telefon: 43 27 00 00. Svarer næsten altid - også uden for åbningstid.
          </Paragraph>
        </Col>
        <Col xs={12} sm={6}>
          <ImageKontakt name="kontakt.rane-lille.jpg" alt="Rane på kontor for modtagelse af ordre på øl &amp; sodavand" />
          <br /><br />
          <Paragraph>
            <Bold>
              Rane Irgens: Firmaets 1. mand
            </Bold>
          </Paragraph>
          <Paragraph>
            Tager sig af kontor såvel som lager arbejde. Specielt tekniske spørgsmål med fadølsanlæg.
          </Paragraph>
          <Paragraph>
            Mobil: 20 14 52 09
          </Paragraph>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={6}>
          <ImageKontakt name="kontakt.gitte-lille.jpg" alt="Gitte Mikkelsen - Kontordame" />
          <br /><br />
          <Paragraph>
            <Bold>
              Gitte Mikkelsen: Kontordame.
            </Bold>
          </Paragraph>
          <Paragraph>
            Gitte står hovedsageligt for modtagelse af opkald og
            bestillinger og levererer en god betjening til vores kunder der ringer ind. Hun står
            også får behandling af onlinebestillinger fra faste, samt nye kunder.
            Lejlighedsvis kører Gitte også ud og fylder sodavandsautomater op.
          </Paragraph>
          <Paragraph>
            Ring til Gitte på: 43 27 00 00
          </Paragraph>
        </Col>
        <Col xs={12} sm={6}>
          <ImageKontakt name="kontakt.troels-lille.jpg" alt="Troels Kinthof - Webudvikler" />
          <br /><br />
          <Paragraph>
            <Bold>
              Troels Kinthof: Webudvikler
            </Bold>
          </Paragraph>
          <Paragraph>
            Troels har siden januar 2009 stået for udvikling og vedligeholdelse
            af skafte.dk.
            Han fungerer desuden som vores IT alt-mulig-mand.
            Senest er Troels og Peter begyndt at filme en række <LinkStyled to="/videoer" title="Fadølsvideoer">videoer om fadøl </LinkStyled>
            og han står for tilrettelæggelsen og redigeringen af disse.
            Udover skafte.dk administrerer han også <LinkStyled external to="https://www.facebook.com/skafte.dk" title="Skafte Øl og Vand på Facebook">Skafte Øl og Vand på Facebook.</LinkStyled>
          </Paragraph>
          <Paragraph>
            Mobil: 28 77 90 08
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Paragraph>
            <Bold>
              Oplysning om klagemuligheder
            </Bold>
            <br />
            Hvis du vil klage over dit køb,
            skal du rette henvendelse til <LinkStyled anchor to="mailto:peter@skafte.dk">peter@skafte.dk</LinkStyled>.
            Hvis det ikke lykkes os at finde en løsning,
            kan du indgive en klage til relevante nævn på området,
            såfremt betingelserne herfor er opfyldt.
          </Paragraph>
          <Paragraph>
            En klage over en vare eller tjenesteydelse købt hos os kan indgives
            til Konkurrence- og Forbrugerstyrelsens Center for Klageløsning,
            Carl Jacobsens Vej 35, 2500 Valby.
            Du kan klage til Center for Klageløsning via <LinkStyled external to="http://www.forbrug.dk">www.forbrug.dk</LinkStyled>.
          </Paragraph>
          <Paragraph>
            EU-Kommissionens online klageportal kan også anvendes ved
            indgivelse af en klage.
            Det er særlig relevant, hvis du er forbruger med bopæl
            i et andet EU-land. Klage indgives her - <LinkStyled external to="http://ec.europa.eu/odr">http://ec.europa.eu/odr</LinkStyled>. Ved indgivelse af en klage skal du angive vores e-mail adresse <LinkStyled anchor to="mailto:peter@skafte.dk">peter@skafte.dk</LinkStyled>.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
